import { render, staticRenderFns } from "./EmpresaDocumento.vue?vue&type=template&id=b399f664"
import script from "./EmpresaDocumento.vue?vue&type=script&lang=js"
export * from "./EmpresaDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports